/**
Author - Venkatesh Pullaganti
Git - https://github.com/venkatesh1146
**/

import React, {useState, useEffect} from 'react';
import {PropTypes} from 'prop-types';
import IMAGES from 'constants/Images';

import UploadDocumentContainer from 'components/UploadDocument/UploadDocument.container';
import {getBankProofMetaData, uploadBankProof} from 'api';
import {BANK_VERIFICATION_TYPE, KYC_FIREBASE_EVENTS} from 'constants/kycFirebaseEvents';
import {handleApiError} from 'helpers';
import {logKycFirebaseEvent} from 'utils/logFirebaseEvents';
import {LoaderContainer, Spinner} from '../commons';

const propTypes = {
  updateStatus: PropTypes.func.isRequired,
  handleGoBack: PropTypes.func.isRequired,
  kycData: PropTypes.object,
};

const BankProof = ({updateStatus, handleGoBack, kycData}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isFetchingMetaData, setIsFetchingMetaData] = useState(false);
  const [BankProofMetaData, setBankProofMetaData] = useState(null);
  const [errorMessage, setErrorMessage] = useState();

  const handleSubmitFile = async (formData, docType) => {
    setErrorMessage(false);
    setIsUploading(true);
    try {
      const res = await uploadBankProof(formData, docType);
      if (res.status === 200) {
        logKycFirebaseEvent(kycData?.flow, KYC_FIREBASE_EVENTS.BANK_ADDED, {
          verificationType: BANK_VERIFICATION_TYPE.MANUAL,
        });
        updateStatus();
      } else if (res.status === 400) {
        if (res.status === 400) {
          res.json().then((data) => {
            setErrorMessage(data.detail);
          });
        }
      } else if (!res.ok) {
        throw {
          response: {
            status: 400,
            data: {
              detail: {
                message: 'File Format Not Supported',
              },
            },
          },
        };
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsUploading(false);
    }
  };

  const fetchMetaData = async () => {
    setIsFetchingMetaData(true);
    try {
      const res = await getBankProofMetaData();
      setBankProofMetaData(res.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsFetchingMetaData(false);
    }
  };

  useEffect(() => {
    fetchMetaData();
  }, []);

  const shouldShowChangeAccountButton = kycData?.flow !== 'MF_MINOR';

  let uploadMessage = '';
  if (BankProofMetaData?.extras?.bank?.account) {
    uploadMessage += `
    <p> <b>Manually Entered Bank Account Details</b></p>
    <div>Account number: ${BankProofMetaData?.extras?.bank?.account} <br />
    IFSC code: ${BankProofMetaData?.extras?.bank?.ifsc}</div> `;
  }

  return isFetchingMetaData ? (
    <LoaderContainer>
      <Spinner color="blue" message="Checking your bank details, Please do not close the window" />
    </LoaderContainer>
  ) : (
    <>
      {BankProofMetaData ? (
        <UploadDocumentContainer
          isLoading={isUploading}
          onSubmitDocument={handleSubmitFile}
          instructions={BankProofMetaData?.extras?.instructions}
          subHeading={`<span className='warning-text'>${BankProofMetaData?.cardTitle}</span>`}
          heading={'Bank Proof Required'}
          documentOptions={BankProofMetaData?.allowedBankProofs}
          errorMessage={errorMessage}
          uploadMessage={uploadMessage}
          referenceImage={IMAGES.cancel_cheque}
          successStyleOnUpload
          goBackButton={{
            buttonText: '← Change Account Number',
            callback: () =>
              handleGoBack({
                bank_proof: 'You have manually choose to reset.',
                penny_drop: 'You have manually choose to reset.',
              }),
            show: shouldShowChangeAccountButton,
            info: ``,
          }}
        />
      ) : null}
    </>
  );
};

BankProof.prototype = propTypes;
export default BankProof;
